import { useMemo } from 'react';
import { useQueries } from '@tanstack/react-query';
import apiClient from '../../../hooks/apiClient';

const buildArticleKey = (uuid) => ['inventoryArticles', 'detail', uuid];

const fetchInventoryArticle = async (uuid) => {
  const response = await apiClient.get(`inventory_articles/${uuid}`);
  return response.data;
};

export const useInventoryArticlesByUuids = (uuids = [], enabled = false) => {
  const uniqueUuids = useMemo(
    () => [...new Set((uuids || []).filter(Boolean))],
    [uuids]
  );

  const queries = useQueries({
    queries: uniqueUuids.map((uuid) => ({
      queryKey: buildArticleKey(uuid),
      queryFn: () => fetchInventoryArticle(uuid),
      enabled: enabled && Boolean(uuid),
      staleTime: 5 * 60 * 1000,
      retry: false,
    })),
  });

  const articles = useMemo(
    () => queries.map((query) => query.data).filter(Boolean),
    [queries]
  );

  const isLoading = enabled && queries.some((query) => query.isLoading);

  return { articles, isLoading };
};
